module.exports = __webpack_public_path__ + "img/wx_logo.6174e2c3.png";